/**
 * In-tree UI domain bundles. Employment lives in tenant packs.
 */
import type { TenantPluginRegister } from '@/plugin/types'

export const DOMAIN_BUNDLES: ReadonlyArray<readonly [string, TenantPluginRegister]> = []
